/* eslint-disable react/jsx-key */
import React, { useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'
import { getApiTargetInfo } from 'core'

import { connect } from 'react-redux'
import {
  getSystemConfigurationInfo,
  postSystemConfigurationInfo,
  deleteSystemConfigurationInfo,
} from 'api/pgads.js'

import { Input, Button } from 'antd'

import CommonScreen from './CommonScreen'

const headers = [
  strCol({
    ident: 'key',
    display: 'Module Name',
    width: 350,
    isFiltered: true,
    isKey: true,
    isRequired: true,
  }),
  strCol({
    ident: 'value',
    display: 'Setting',
    width: 550,
    isFiltered: true,
    isRequired: true,
    ellipsis: true,
  }),
  strCol({
    ident: 'description',
    display: 'Description',
    width: 1350,
    isFiltered: true,
    alignment: 'left',
  }),
]

const retrieveTask = apiTargetInfo => getSystemConfigurationInfo(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  postSystemConfigurationInfo(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteSystemConfigurationInfo(apiTargetInfo)(data)

const title = 'System Configuration'

const SystemConfiguration = () => {
  const [insertEvent, setInsertEvent] = useState(false)

  // const setData = data => {
  //   setInsertData({ ...insertData, ...data })
  // }
  // const onCancel = () => {
  //   setInsertEvent(false)
  // }

  // const onAdd = ({ hide, retrieve }) => {
  //   if (insertData.key === undefined || insertData.key.trim().length == 0) {
  //     message.error('Please, Insert Module Name before Save')
  //     return
  //   }

  //   modifyTask(apiTargetInfo)([insertData]).fork(setErr, _ => {
  //     message.info('Data Saved')
  //     setInsertEvent(!hide)
  //     setInsertData({})
  //     retrieve && retrieve()
  //   })
  // }
  // useEffect(() => {
  //   setInsertData({})
  // }, [insertEvent])

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return [
      <table
        style={{
          borderSpacing: '10px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <td style={{ width: '100px' }}>Module Name : </td>
            <td style={{ width: '300px' }}>
              <Input
                placeholder="Module Name"
                value={insertData.key}
                onChange={e =>
                  setInsertData({ ...insertData, key: e.target.value })
                }
              />
            </td>
            <td style={{ width: '50px' }} />
            <td style={{ width: '70px' }}>Setting : </td>
            <td style={{ width: '300px' }}>
              <Input
                placeholder="Setting"
                value={insertData.value}
                onChange={e =>
                  setInsertData({ ...insertData, value: e.target.value })
                }
              />
            </td>
            <td />
          </tr>

          <tr>
            <td>Description : </td>
            <td colSpan={4}>
              <Input
                placeholder="Description"
                value={insertData.description}
                onChange={e =>
                  setInsertData({ ...insertData, description: e.target.value })
                }
              />
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
            </td>
            <td>
              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>,
    ]
  }

  // <SimpleScreen
  //   title={title}
  //   headers={headers}
  //   renderCriteria={props => <RetrieveCriteria {...props} />}
  //   getModifyTask={modifyTask(apiTargetInfo)}
  //   getDeleteTask={deleteTask(apiTargetInfo)}
  //   getRetrieveTask={retrieveTask(apiTargetInfo)}
  //   gridProps={{
  //     rowsPerPage: 30,
  //   }}
  //   isEditable
  // />

  return (
    <CommonScreen
      title={title}
      header={headers}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.key}
      autoRetrieve
      sortOptions={[{ ident: 'key', display: 'Module Name', sortOrder: 'asc' }]}
      insertComp={insertEvent && insertComp}
      insertCompHeight={150}
      onInsertEvent={b => setInsertEvent(b)}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(SystemConfiguration)
